import * as angular from 'angular';
import {IPromise} from 'angular';
import {AgentInventoryTransactionModel, AgentInventoryTransactionResponse} from '../angular/models/agent-inventory-transaction.model';
import {BringozApi} from '../../persistence-layer/models/bringoz-api.model';

export class AgentInventoryRequestsService {

  /* @ngInject */
  constructor(private AgentInventoryAPI: BringozApi, private $agentInventory) {
  }

  getTransactions(queryParams?: any): IPromise<AgentInventoryTransactionResponse> {
    const api = this.AgentInventoryAPI.actions.getTransactions;
    return this.$$call(api, queryParams, {}, {});
  }

  createLoadTransaction(transaction: any): IPromise<any> {
    const api = this.AgentInventoryAPI.actions.createLoadTransaction;
    const payload = [transaction];
    return this.$$call(api, {}, payload, {});
  }

  createUnloadTransaction(transaction: any): IPromise<any> {
    const api = this.AgentInventoryAPI.actions.createUnloadTransaction;
    const payload = [transaction];
    return this.$$call(api, {}, payload, {});
  }

  // Private method to call API
  private $$call(_apiCall, _params, _data, _options) {
    return this.$agentInventory().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.agent-inventory')
  .service('agentInventoryRequestsService', AgentInventoryRequestsService);

